import moment from 'moment';

function test_mixin() {
  window.console.log('TEST SITE SPECIFIC MIXIN');
}

const DEFAULT_SCORE_MAP = {
  10: 'Eccezionale',
  9: 'Eccellente',
  8: 'Ottimo',
  7: 'Buono',
  6: 'Carino',
};

function textual_score(score_map = DEFAULT_SCORE_MAP) {
  const sorted_keys = Object.keys(score_map).sort((a, b) => a - b);
  return function (score) {
    const key = sorted_keys.find((current_key, index) => {
      const next_key = Number(sorted_keys[index + 1]);
      return score >= current_key && (score < next_key || !next_key);
    });
    return score_map[key] || 'Mediocre';
  };
}

export const get_refundability = (params) => {
  const { refundability = {} } = params || {};
  const {
    refundable_before,
    refundable = false,
    format: refund_date_format = moment.ISO_8601,
    result_date_format = 'DD-MM-YYYY',
  } = refundability;

  const non_refundable = { refundable: false, text: 'Non rimborsabile' };

  if (!refundable_before || !refundable) {
    return non_refundable;
  }

  const cancellation_date = moment(refundable_before, refund_date_format);
  if (!cancellation_date.isValid()) {
    return non_refundable;
  }

  return {
    refundable: true,
    text: `Cancellazione gratuita fino al ${cancellation_date.format(result_date_format)}`,
  };
};

export default {
  methods: {
    test_mixin,
    textual_score,
  },
};
